import { render, staticRenderFns } from "./DatatableReceivers.vue?vue&type=template&id=09914840"
import script from "./DatatableReceivers.vue?vue&type=script&lang=js"
export * from "./DatatableReceivers.vue?vue&type=script&lang=js"
import style0 from "./DatatableReceivers.vue?vue&type=style&index=0&id=09914840&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports